import { UniDriver } from '@wix/wix-ui-test-utils/dist/types/unidriver';
import { baseUniDriverFactory } from '../test-utils/utils/unidriver';

export const counterBadgeDriverFactory = (base: UniDriver) => {
  return {
    ...baseUniDriverFactory(base),
    // Gets CounterBadge content text if children are text based
    getContentText: (): Promise<string> => base.text(),
    // Gets passed locale
    getLocale: (): Promise<string> =>
      base.attr('data-locale') as Promise<string>,
  };
};

export type CounterBadgeUniDriver = ReturnType<
  typeof counterBadgeDriverFactory
>;
